import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

export type CookieConsentDecision = 'accepted' | 'refused' | null;

@Injectable({providedIn: 'root'})
export class CookieConsentService {
  private readonly storageKey = 'cookieConsent';
  private decisionSubject = new BehaviorSubject<CookieConsentDecision>(this.read());
  decision$: Observable<CookieConsentDecision> = this.decisionSubject.asObservable();

  get decision(): CookieConsentDecision {
    return this.decisionSubject.value;
  }

  get hasAccepted(): boolean {
    return this.decision === 'accepted';
  }

  get hasDecided(): boolean {
    return this.decision !== null;
  }

  accept(): void {
    this.set('accepted');
  }

  refuse(): void {
    this.set('refused');
  }

  private set(value: Exclude<CookieConsentDecision, null>): void {
    localStorage.setItem(this.storageKey, value);
    this.decisionSubject.next(value);
  }

  private read(): CookieConsentDecision {
    const value = localStorage.getItem(this.storageKey);
    return value === 'accepted' || value === 'refused' ? value : null;
  }
}
